const comments = [
  {
    id: 1,
    name: '银幕旅人',
    avatar: '影',
    rating: 5,
    time: '2小时前',
    content: '用了星空电影网半年了，最让我惊艳的就是加载速度。以前在其他平台等缓冲等到崩溃，这边的秒开体验真的回不去了。画质也稳，推荐给了身边所有追剧的朋友！',
    film: '《沙丘2》',
  },
  {
    id: 2,
    name: '周末放映员',
    avatar: '放',
    rating: 5,
    time: '5小时前',
    content: '片源更新速度比想象中快很多，院线刚下没多久的片子这边就有了高清版。无卡顿播放对深夜追片党来说简直是救星，网络一般的时候也能流畅看完。',
    film: '《奥本海默》',
  },
  {
    id: 3,
    name: '电影笔记',
    avatar: '记',
    rating: 4,
    time: '昨天',
    content: '分类索引做得不错，找老片很方便。播放器响应很快，拖动进度条几乎没有延迟。唯一希望的是能增加一些经典黑白片的修复版资源，老电影爱好者的小心愿。',
    film: '《教父》',
  },
  {
    id: 4,
    name: '追光者',
    avatar: '追',
    rating: 5,
    time: '昨天',
    content: '被朋友安利过来的，第一次用就被圈粉了。界面干净没广告弹窗，高清片源加载确实快。现在每天下班回家第一件事就是打开星空电影网看一部电影放松。',
    film: '《星际穿越》',
  },
  {
    id: 5,
    name: '深夜放映室',
    avatar: '室',
    rating: 5,
    time: '2天前',
    content: '家里网速一般，但星空电影网的优化确实到位，高清模式下也能流畅播放不缓冲。片库齐全，从热门新片到小众文艺片都有，观影体验非常舒适。',
    film: '《寄生虫》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            影迷热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自全国影迷的真实观影反馈，每一句都是对流畅播放体验的认可
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment) => (
            <article
              key={comment.id}
              className="bg-background-200/60 rounded-lg p-5 md:p-6 border border-background-300/30 hover:border-background-300/50 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-400 text-sm font-bold font-heading">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-200 truncate">{comment.name}</h3>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <span key={i} className="w-3 h-3 flex items-center justify-center">
                        <i
                          className={`text-xs ${
                            i < comment.rating ? 'text-primary-500 ri-star-fill' : 'text-foreground-700 ri-star-line'
                          }`}
                        ></i>
                      </span>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-600 whitespace-nowrap">{comment.time}</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-3">{comment.content}</p>
              <span className="inline-block text-xs text-primary-500 bg-primary-500/10 px-2 py-0.5 rounded">
                {comment.film}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}